import icon from "../assets/img/icon.png"
import "../styles/FadeIn.css"
import "../styles/TwoColumnLayout.css"
import defaultIcon from "../assets/img/icon.png"

export default function TwoColumnLayout({leftContent, rightContent, icon}) {
    const imageStyle = {
        width: "48px",
        marginBottom: "80px",
    }
    return (
        <div className="container mt-5">
            <div className="row">
                <div className="col-lg-4 text-end d-flex flex-column align-items-end">
                    {leftContent}
                </div>
                <div className="col-lg-8 ps-lg-5 fade-in">
                    {rightContent}
                    <hr/>
                    <img style={imageStyle} src={icon || defaultIcon} alt={"mpospirit"}/>
                </div>
            </div>
        </div>
    )
}

